import { render, staticRenderFns } from "./WorkPeriodTemplateForm.vue?vue&type=template&id=72b83f26&scoped=true&"
import script from "./WorkPeriodTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./WorkPeriodTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b83f26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
